// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Sort: React.FC<{ width?: number; height?: number }> = ({ width = 9, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 12">
            <path
                fill="currentColor"
                d="M.056 4.781a.766.766 0 0 0 .702.469h7.484a.766.766 0 0 0 .702-.469c.117-.281.046-.586-.164-.82L5.038.21a.791.791 0 0 0-1.076 0L.22 3.96c-.21.234-.28.539-.14.82H.056Zm0 2.438c-.117.281-.046.586.164.82l3.742 3.75a.791.791 0 0 0 1.076 0L8.78 8.04c.21-.234.28-.539.164-.82a.766.766 0 0 0-.702-.469H.758a.766.766 0 0 0-.702.469Z"
            />
        </svg>
    );
};

export default React.memo(Sort);
